import React from 'react';
import { BrowserRouter  as Router, Routes, Route } from 'react-router-dom';
import ConfirmationPage from './pages/ConfirmationPage';
import Footer from './components/Footer';
import { RepertorioComportamental } from './pages/RepertorioComportamental';
import Index from './pages/Index';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RepertorioComportamental/>} />
        <Route path="/confirmado" element={<ConfirmationPage/>} />
        <Route path="/rc" element ={<RepertorioComportamental/>}/>
      </Routes>
      <Footer/>
    </Router>
);
}

export default App;
